import { extend } from 'lodash'

import { BaseModel } from '../base-model'
import { ProductCategoryData } from './product-category.data'

export class ProductCategory extends BaseModel {
  label: string
  color: string
  disableIntake?: boolean
  hidden?: boolean
  hideAppointments?: boolean
  resources?: string[]

  constructor(data: ProductCategoryData) {
    super(data)
    this.label = data.label
    this.color = data.color
    this.disableIntake = data.disableIntake
    this.hidden = data.hidden
    this.hideAppointments = data.hideAppointments
    this.resources = data.resources
  }

  override toJSON() {
    return extend(super.toJSON(), {
      label: this.label,
      color: this.color,
      disableIntake: this.disableIntake,
      hidden: this.hidden,
      hideAppointments: this.hideAppointments,
      resources: this.resources,
    })
  }
}
